module.exports = __webpack_public_path__ + "static/media/distanceLearningVideoPic.8851d3da.png";